import { mapGetters, mapMutations } from "vuex";
const invoiceParameterModuleName = "invoice-parameter";
export default {
  name: "InvoiceParametersRules",

  methods: {
    ...mapMutations({
      setShowCreateRuleInactiveModal: `${invoiceParameterModuleName}/setShowCreateRuleInactiveModal`,
    }),
    /**
     * Exibe o modal "Criar uma regra com status Inativo" - CreateRuleInactiveModal.
     *
     * Regra de negócio: não permitir criação de novas configurações de regra com status inativo.
     *
     * @returns {boolean} Verdadeiro se existir configuração nova com status inativo.
     */
    newConfigInactiveRule() {
      if (this.form.configs.some((config) => config.new === true && config.active === false)) {
        this.setShowCreateRuleInactiveModal(true);
        return false;
      }
      return true;
    }
  },
  computed: {
    ...mapGetters({
      configs: 'invoice-parameter/configs',
    }),
  }
}